import gql from 'graphql-tag';

export const createDocumentField = gql`
  mutation CreateDocumentField(
    $documentId: String!
    $pageId: String!
    $fieldType: FieldTypes!
    $fieldLabel: String!
    $fieldValue: String!
    $fieldOptions: [String!]!
    $recipientId: String
    $fieldTop: Int!
    $fieldLeft: Int!
    $fieldWidth: Int!
    $fieldHeight: Int!
    $isEditable: Boolean!
    $isRequired: Boolean!
    $validationRegex: String!
    $validationWarning: String!
    $fieldSource: FieldSources!
    $isCollectable: Boolean!
  ) {
    createDocumentField(
      documentId: $documentId
      pageId: $pageId
      fieldType: $fieldType
      fieldLabel: $fieldLabel
      fieldValue: $fieldValue
      fieldOptions: $fieldOptions
      recipientId: $recipientId
      fieldTop: $fieldTop
      fieldLeft: $fieldLeft
      fieldWidth: $fieldWidth
      fieldHeight: $fieldHeight
      isEditable: $isEditable
      isRequired: $isRequired
      validationRegex: $validationRegex
      validationWarning: $validationWarning
      fieldSource: $fieldSource
      isCollectable: $isCollectable
    ) {
      id
    }
  }
`;

export const updateDocumentField = gql`
  mutation UpdateDocumentField(
    $id: String!
    $documentId: String
    $pageId: String
    $fieldLabel: String
    $fieldValue: String
    $fieldOptions: [String!]
    $recipientId: String
    $fieldSource: FieldSources
    $fieldTop: Int
    $fieldLeft: Int
    $fieldWidth: Int
    $fieldHeight: Int
    $isCollectable: Boolean
    $isEditable: Boolean
    $isRequired: Boolean
    $validationRegex: String
    $validationWarning: String
  ) {
    updateDocumentField(
      id: $id
      documentId: $documentId
      pageId: $pageId
      fieldLabel: $fieldLabel
      fieldValue: $fieldValue
      fieldOptions: $fieldOptions
      recipientId: $recipientId
      fieldSource: $fieldSource
      fieldTop: $fieldTop
      fieldLeft: $fieldLeft
      fieldWidth: $fieldWidth
      fieldHeight: $fieldHeight
      isCollectable: $isCollectable
      isEditable: $isEditable
      isRequired: $isRequired
      validationRegex: $validationRegex
      validationWarning: $validationWarning
    ) {
      id
    }
  }
`;

export const updateDocumentFields = gql`
  mutation UpdateDocumentFields($fields: [UpdateDocumentFieldArgs!]!) {
    updateDocumentFields(payload: { fields: $fields }) {
      id
    }
  }
`;

export const deleteDocumentFields = gql`
  mutation DeleteDocumentFields($ids: [String!]!) {
    deleteDocumentFields(ids: $ids)
  }
`;

export const createDocumentFields = gql`
  mutation CreateDocumentFields($fields: [DocumentFieldArgs!]!) {
    createDocumentFields(args: { fields: $fields }) {
      id
      documentId
      pageId
      fieldType
      fieldLabel
      fieldValue
      fieldOptions
      recipientId
      fieldTop
      fieldLeft
      fieldWidth
      fieldHeight
      fieldSource
      isCollectable
      isEditable
      isRequired
      validationRegex
      validationWarning
      signatureBiometric
    }
  }
`;
